export class SynchroUpIdMapping {
    private static instance: SynchroUpIdMapping = null as any

    public static getInstance() {
        if (!SynchroUpIdMapping.instance) {
            SynchroUpIdMapping.instance = new SynchroUpIdMapping()
        }

        return SynchroUpIdMapping.instance
    }

    private synchronizationMap: {[key: string]: string}

    constructor() {
        this.synchronizationMap = {}
    }

    public async getNewId(oldId: string): Promise<string | undefined> {
        return this.synchronizationMap[oldId]
    }

    public async setNewId(oldId: string, newId: string) {
        this.synchronizationMap[oldId] = newId
    }
}